import { createAction } from '@reduxjs/toolkit';
import { ImageViewerSettings } from 'reducers/main';

const MainActions = {
  ASK_ANOTHER_QUESTION: 'set/another_question',
  CLEAR_IMAGE_VIEWER: 'clear/imageViewer',
  CLOSE_WIDGET: 'closeWidget',
  NAVIGATE_BACK: 'navigate/back',
  NAVIGATE_TO: 'navigate/to',
  OPEN_WIDGET: 'openWidget',
  RESET_WIDGET: 'reset/widget',
  SET_IMAGE_VIEWER: 'set/imageViewer',
  SET_IS_MOBILE: 'set/setIsMobile',
  SET_IS_WIDGET_VISIBLE: 'main/setIsWidgetVisible',
  SET_SELECTED_ANSWER_INDEX: 'set/selected_answer_index',
  SET_VISUAL_VIEWPORT_OFFSET: 'set/visualViewportOffset',
  START_OVER: 'set/start',
} as const;

export const resetWidget = createAction(MainActions.RESET_WIDGET);
export const startOver = createAction(MainActions.START_OVER);

export const navigateTo = createAction<string>(MainActions.NAVIGATE_TO);
export const navigateBack = createAction(MainActions.NAVIGATE_BACK);
export const setIsMobile = createAction<boolean>(MainActions.SET_IS_MOBILE);

export const setIsWidgetVisible = createAction<boolean>(
  MainActions.SET_IS_WIDGET_VISIBLE,
);
export const openWidget = createAction(MainActions.OPEN_WIDGET);
export const closeWidget = createAction(MainActions.CLOSE_WIDGET);

export const setSelectedAnswerIndex = createAction<number>(
  MainActions.SET_SELECTED_ANSWER_INDEX,
);

export const setVisualViewportOffset = createAction<{
  offsetLeft: number;
  offsetTop: number;
}>(MainActions.SET_VISUAL_VIEWPORT_OFFSET);

export const setImageViewer = createAction<ImageViewerSettings>(
  MainActions.SET_IMAGE_VIEWER,
);
export const clearImageViewer = createAction(MainActions.CLEAR_IMAGE_VIEWER);
